import { Formik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { updateProfileSchema } from "../../../utils/schema";
import ErrorMessage from "../../../components/ErrorMessage";
import { pageRoutes } from "../../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../redux/action/authAction";

const EditProfileForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileDetail } = useSelector((state) => state.authReducer);
  const [imagePreview, setImagePreview] = useState(null);
  const [profile_images, setProfileImages] = useState(
    profileDetail?.profile_image
  );
  const initialState = {
    name: profileDetail?.name ?? "",
    email: profileDetail?.email ?? "",
    number: profileDetail?.number ?? "",
  };

  const handleUpdateProfile = (values) => {
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.profile);
      }
    };
    const data = new FormData();
    data.append("name", values?.name);
    data.append("email", values?.email);
    data.append("number", values?.number);
    {
      imagePreview && data.append("profile_image", imagePreview);
    }

    dispatch(updateProfile({ payload: data, callback }));
  };

  return (
    <div class="col-md-8 mb-4 offset-md-1">
      <div class="ct_profile_white_bg">
        <div className="mb-4">
          <a
            className="navbar-brand ct_logo_text"
            href="javascript:void(0)"
            onClick={() => navigate(-1)}
          >
            <i className="fa-solid fa-arrow-left"></i> Back
          </a>
        </div>
        <div class="ct_section_title">
          <h2 class="section-title mb-4 text-center">
            <strong>Edit Profile</strong>
          </h2>
        </div>
        <Formik
          initialValues={initialState}
          validationSchema={updateProfileSchema}
          onSubmit={(values, actions) => {
            handleUpdateProfile(values, actions);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div class="ct_profile_pic">
                <div
                  class="position-relative"
                  style={{ width: "140px", marginInline: "auto" }}
                >
                  <label
                    htmlFor="profile_images"
                    style={{ cursor: "pointer", position: "relative" }}
                  >
                    <input
                      type="file"
                      id="profile_images"
                      accept="image/*"
                      className="d-none ct_upload_img"
                      onChange={(event) =>
                        setImagePreview(event.target.files[0])
                      }
                    />

                    {imagePreview ? (
                      
                      <>
                      <img
                        src={URL.createObjectURL(imagePreview)}
                        alt="Profile Preview"
                        className="ct_img_66"
                      />
                       <div className="ct_edit_profile_icon_camera">
                        <i class="fa-solid fa-pencil"></i>
                        </div>
                      </>
                    ) : (
                      <>
                        <img
                          src={profile_images ?? "./images/user_profile.png"}
                          alt="Default Profile"
                          className="ct_img_66"
                        />
                        <div className="ct_edit_profile_icon_camera">
                        <i class="fa-solid fa-pencil"></i>
                        </div>
                      </>
                    )}
                  </label>
                </div>
                <h4 class="ct_fs_24 mt-3">{profileDetail?.name ?? ""}</h4>
              </div>
              <div class="row">
                <div class="col-md-12 ">
                  <div class="ct_input-group mb-4">
                    <input
                      required=""
                      type="text"
                      autocomplete="off"
                      class="ct_input"
                      name="name"
                      id="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                    />
                    <label class="ct_user-label">Name</label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="name"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="col-md-12 ct_input-group mb-4">
                    <input
                      required=""
                      type="text"
                      autocomplete="off"
                      class="ct_input ct_diable_emaill"
                      name="email" 
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      disabled={true}
                    />
                    <label class="ct_user-label">Email</label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="email"
                    />
                  </div>
                </div>
                <div class="col-md-12 ">
                  <div class="ct_input-group mb-4">
                    <input
                      required=""
                      type="text"
                      name="number"
                      autocomplete="off"
                      class="ct_input"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.number}
                      onWheel={(e) => e.target.blur()}
                    
                   
                    />
                    <label class="ct_user-label">Number</label>
                    <ErrorMessage
                      errors={errors}
                      touched={touched}
                      fieldName="number"
                    />
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button class="btn btn-secondary ct_btn_animate mt-4 text-center mx-auto " type="button" onClick={handleSubmit}>
                  Update
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EditProfileForm;
